import Icon from './icon.vue'
export default Icon



// WEBPACK FOOTER //
// ./src/common-components/icon/index.js